import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { FormErrorMessage } from 'site-modules/data-privacy-request/components/form-error-message/form-error-message';
import { FormField } from 'site-modules/shared/components/form-field/form-field';

import './data-privacy-form-field.scss';

export const DataPrivacyFormField = ({
  component: Component = FormField,
  fieldRef,
  name,
  withCharacterLimit = false,
  error,
  onChange = noop,
  maxLength = undefined,
  value = undefined,
  ...rest
}) => {
  const [charactersLimit, setCharactersLimit] = useState(maxLength - (value || '').length);

  const errorId = `${name}-error`;

  const refCallback = useCallback(field => fieldRef(name, field), [fieldRef, name]);

  const handleFieldChange = useCallback(
    event => {
      onChange(event);

      if (!withCharacterLimit) {
        return;
      }

      setCharactersLimit(maxLength - event.target.value.length);
    },
    [maxLength, onChange, withCharacterLimit]
  );

  return (
    <div className="data-privacy-form-field">
      <Component
        ref={refCallback}
        onChange={handleFieldChange}
        name={name}
        maxLength={maxLength}
        ariaInvalid={!!error}
        ariaDescribedBy={errorId}
        value={value}
        {...rest}
      />
      <div className="error-section d-flex">
        {error && <FormErrorMessage id={errorId} message={error} />}
        {withCharacterLimit && (
          <span className="ms-auto medium text-gray-dark">Character limit: {charactersLimit}</span>
        )}
      </div>
    </div>
  );
};

DataPrivacyFormField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  component: PropTypes.elementType,
  fieldRef: PropTypes.func.isRequired,
  withCharacterLimit: PropTypes.bool,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
};
